import { Tag } from 'antd';
import styled from 'styled-components';

export const StyledTag = styled(Tag)`
  background-color: rgb(255 254 234);
  color: black;
  border: 0.5px, solid, grey;
  font-weight: 400;
`;
